const initialState = {
    favorites: [],
		loadingStatus: false,
		errorStatus: false
  };

  function favoriteReducer(state = initialState, action) {
  const {favorites} = state

	// console.log(favorites, favorites.length,'ini');
  switch (action.type) {
    case "ADD_FAVORITES":
			let status = false
			if(favorites.length === 0) {
				status = true
			}
			else{
				favorites.forEach(favorite => {
					if (action.favorites.id === favorite.id) {
						status = false
						console.log('double');
						// return {
						// 	...state,
						// 	errorStatus: true
						// }
					}
					else {
						status = true
						}
				})
			}

			if(status === true) {
				return {
					...state,
					favorites: favorites.concat(action.favorites)
				}
			}
			
    case "CHANGE_LOADING_STATUS":
			return {
					...state,
					loadingStatus: action.loadingStatus
			}

    default:
      return state;
  }
}

export default favoriteReducer;

    // case "CHANGE_AGE":
    //   return {
    //     ...state,
    //     age: age + 1
    //   };

  // function reducer(state = initialState, action) {
    // Ketika ada sebuah action, maka kita harus membuat state yang baru
    // if (action.type === "CHANGE_NAME") {
    //   console.log("reducer nya dijalankan", state, action);
    //   const newState = {
    //     ...state,
    //     name: action.payload
    //   };
  
    //   return newState;
    // }
  
    // if (action.type === "CHANGE_AGE") {
    //   console.log(action, state);
    //   return {
    //     ...state,
    //     age: state.age + 1
    //   };
    // }